module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible && _vm.atRoot && (_vm.loading || _vm.loadError || _vm.entries.length)) ? _c('div', {
    staticClass: "disk-quick"
  }, [_c('div', {
    staticClass: "disk-quick-bar"
  }, [_c('span', {
    staticClass: "disk-quick-label"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-navigate-outline",
      "size": "16"
    }
  }), _vm._v("\n      资料导航\n    ")], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "disk-quick-tip"
  }, [_vm._v("加载导航…")]) : (_vm.loadError) ? _c('div', {
    staticClass: "disk-quick-tip"
  }, [_vm._v("\n      导航加载失败\n      "), _c('a', {
    staticClass: "disk-group-nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reload.apply(null, arguments)
      }
    }
  }, [_vm._v("重试")])]) : _c('div', {
    staticClass: "disk-quick-items"
  }, _vm._l((_vm.entries), function(item) {
    return _c('a', {
      key: item.key,
      staticClass: "disk-quick-item",
      attrs: {
        "title": item.summary || item.title
      },
      on: {
        "click": function($event) {
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.folderIcon,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }), 0), _vm._v(" "), (_vm.entries.length) ? _c('a', {
    staticClass: "disk-quick-all",
    on: {
      "click": function($event) {
        _vm.drawerOpen = true
      }
    }
  }, [_vm._v("\n      全部 " + _vm._s(_vm.entries.length) + " 个\n      "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-right"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.drawerOpen) ? _c('div', {
    staticClass: "disk-nav-drawer"
  }, [_c('div', {
    staticClass: "disk-nav-drawer-head"
  }, [_c('strong', [_c('Icon', {
    attrs: {
      "type": "ios-navigate-outline",
      "size": "18"
    }
  }), _vm._v("教研群资料导航")], 1), _vm._v(" "), _c('a', {
    staticClass: "disk-nav-drawer-close",
    attrs: {
      "title": "关闭"
    },
    on: {
      "click": function($event) {
        _vm.drawerOpen = false
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-close-empty",
      "size": "28"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "disk-nav-drawer-tools"
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "icon": "ios-search",
      "placeholder": "搜索导航入口"
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), (_vm.categories.length) ? _c('div', {
    staticClass: "disk-group-nav-cats"
  }, [_c('span', {
    class: ['disk-group-nav-chip', {
      on: !_vm.categoryKey
    }],
    on: {
      "click": function($event) {
        _vm.categoryKey = ''
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.categories), function(cat) {
    return _c('span', {
      key: cat.key,
      class: ['disk-group-nav-chip', {
        on: _vm.categoryKey === cat.key
      }],
      on: {
        "click": function($event) {
          return _vm.toggleCategory(cat.key)
        }
      }
    }, [_vm._v("\n          " + _vm._s(cat.title) + "\n          "), _c('a', {
      staticClass: "disk-group-nav-chip-open",
      attrs: {
        "title": "打开此分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openNode(cat.targetNodeId)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "ios-folder-outline"
      }
    })], 1)])
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "disk-nav-drawer-body"
  }, [(!_vm.filteredEntries.length) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("\n        没有匹配的入口\n        "), (_vm.hasFilter) ? _c('a', {
    staticClass: "disk-group-nav-link",
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilter.apply(null, arguments)
      }
    }
  }, [_vm._v("查看全部")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredEntries), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-group-nav-card",
      on: {
        "click": function($event) {
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_c('img', {
      staticClass: "disk-group-nav-card-icon",
      attrs: {
        "src": _vm.folderIcon,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-main"
    }, [_c('div', {
      staticClass: "disk-group-nav-card-title",
      attrs: {
        "title": item.title
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.summary) ? _c('div', {
      staticClass: "disk-group-nav-card-summary"
    }, [_vm._v(_vm._s(item.summary))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-path"
    }, [_vm._v(_vm._s(item.pathLabel || './'))])]), _vm._v(" "), (_vm.openingId === item.targetNodeId) ? _c('Spin', {
      attrs: {
        "size": "small"
      }
    }) : _c('Icon', {
      staticClass: "disk-group-nav-card-arrow",
      attrs: {
        "type": "ios-arrow-right"
      }
    })], 1)
  })], 2)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e10340","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskGroupNav.vue
// module id = 1828
// module chunks = 8